import { defaultApiState } from '../api.state';

export const diseaseState = {
  apiState: {
    getDiseases: defaultApiState,
    getDisease: defaultApiState,
    addDisease: defaultApiState,
    updateDisease: defaultApiState,
    getCategories: defaultApiState,
  },
  diseases: [],
  disease: undefined,
  categories: [],
};
